import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import { memo } from 'react'
import { useIntl } from 'react-intl'

function MaldivesCharterFareFeatureDetailsSkeleton() {
  const intl = useIntl()
  const loadingAriaLabel = intl.formatMessage({
    id: '4X9z8FhfAATtAyyz_DkF',
    defaultMessage: 'Loading fare inclusions',
    description:
      'Accessibility label announced while the Maldives charter calendar fare card shows a loading placeholder for baggage, meals, and cabin comparison rows until the fare upsell response returns.',
  })

  return (
    <VerticalSpacer
      gap={12}
      aria-busy="true"
      aria-label={loadingAriaLabel}
      role="status"
      data-testid="maldives-fare-details-skeleton"
    >
      <TextLoadingBox typography="body-small" width={72} />
      <VerticalSpacer gap={8}>
        <TextLoadingBox typography="caption-medium" width="100%" />
        <TextLoadingBox typography="caption-medium" width="100%" />
        <TextLoadingBox typography="caption-medium" width="92%" />
      </VerticalSpacer>
      <TextLoadingBox typography="body-small" width={140} />
      <VerticalSpacer gap={8}>
        <TextLoadingBox typography="caption-medium" width="100%" />
        <TextLoadingBox typography="caption-medium" width="100%" />
        <TextLoadingBox typography="caption-medium" width="88%" />
        <TextLoadingBox typography="caption-medium" width="96%" />
      </VerticalSpacer>
    </VerticalSpacer>
  )
}

export default memo(MaldivesCharterFareFeatureDetailsSkeleton)
